<template>
    <el-dialog top="1vh" title="公式编辑" :close-on-click-modal="false" :show-close="false"
        :width="type == 'add' ? '80%' : '50%'" :visible.sync="dialogVisible">
        <el-popover slot="title" v-if="type === 'add'" width="320" placement="bottom" title="题目模板示例：" trigger="click">
            <div style="line-height: 20px;font-size: 12px;border: 1px solid #ccc;padding: 8px;" v-html="qTempltae">
            </div>
            <el-button slot="reference" type="primary">查看新建题目模版</el-button>
        </el-popover>
        <div v-if="type === 'add'" style="display: flex; justify-content: space-between;gap: 44px; align-items: top;">
            <!-- 编辑器容器 -->
            <div style="width: 40%;">
                <div id="wangEditor" style="z-index: 100000;"></div>
            </div>
            <div style="flex: 1;">
                <el-form size="mini" label-width="70px" status-icon ref="ruleForm">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="学科：">
                                <el-select v-model="formData.subject" placeholder="请选择学科">
                                    <el-option v-for="item in selectors.SubjectInfo" :key="item.subjectId"
                                        :label="item.subjectName" :value="item.subjectName"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="年级：">
                                <el-select v-model="formData.grade" placeholder="请选择年级">
                                    <el-option v-for="item in selectors.GradeInfo" :key="item.gradeId"
                                        :label="item.gradeName" :value="item.gradeName"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="题型：">
                                <el-select v-model="formData.qtype" placeholder="请选择题型">
                                    <el-option v-for="item in selectors.QuizTypeInfo" :key="item.id"
                                        :label="item.typeName" :value="item.typeName"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="题类：">
                                <el-select v-model="formData.paperTpye" placeholder="请选择题类">
                                    <el-option v-for="item in selectors.QuizPaperInfo" :key="item.paperTypeId"
                                        :label="item.paperTypeName" :value="item.paperTypeId"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="时间：">
                                <el-select v-model="formData.year" placeholder="请选择时间">
                                    <el-option v-for="item in selectors.QuizTimeOptInfo" :key="item.value"
                                        :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="难度：">
                                <el-input-number v-model="formData.diff" @change="handleChange" :min="1"
                                    :max="5"></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item label="题干：">
                        <div id="title">
                        </div>
                    </el-form-item>
                    <el-form-item v-show="formData.qtype == '选择题' || formData.qtype == '多选题'" label="选项A：">
                        <div id="option_a">
                        </div>
                    </el-form-item>
                    <el-form-item v-show="formData.qtype == '选择题' || formData.qtype == '多选题'" label="选项B：">
                        <div id="option_b">
                        </div>
                    </el-form-item>
                    <el-form-item v-show="formData.option_c && (formData.qtype == '选择题' || formData.qtype == '多选题')"
                        label="选项C：">
                        <div id="option_c">
                        </div>
                    </el-form-item>
                    <el-form-item v-show="formData.option_d && (formData.qtype == '选择题' || formData.qtype == '多选题')"
                        label="选项D：">
                        <div id="option_d">
                        </div>
                    </el-form-item>
                    <el-form-item v-show="formData.option_e && (formData.qtype == '选择题' || formData.qtype == '多选题')"
                        label="选项E：">
                        <div id="option_e">
                        </div>
                    </el-form-item>
                    <el-form-item label="答案：">
                        <div id="answer">
                        </div>
                    </el-form-item>
                    <el-form-item label="解析：">
                        <div id="parse">
                        </div>
                    </el-form-item>
                    <el-form-item label="考点：">
                        <div id="knowledges">
                        </div>
                    </el-form-item>
                    <el-form-item label="来源：">
                         <el-input type="textarea" :rows="2" v-model="formData.source"></el-input>
                    </el-form-item>
                </el-form>

            </div>
        </div>
        <div v-else>
            <div id="wangEditor" style="position: relative;"></div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">关闭</el-button>
            <el-button type="primary" @click="save">保存</el-button>
        </span>
    </el-dialog>


</template>

<script>
import E from 'wangeditor'
import Kityformula from './kityformula'

export default {
    data() {
        return {
            formData: {
                subject: '',
                grade: '',
                qtype: '',
                year: '',
                paperTpye: '',
                source: '',
                diff: '',
                answer2: '',
                knowledges: '',
                parse: '',
                option_a: '',
                option_b: '',
                option_c: '',
                option_d: '',
                option_e: '',
            },
            rightFormData: {
                title: '',
                option_a: '',
                option_b: '',
                option_c: '',
                option_d: '',
                option_e: '',
                answer2: '',
                knowledges: '',
                parse: '',
                source: '',
            },
            qTempltae: '1．假设雨点下落过程中受到空气的阻力与雨点<br> &nbsp;&nbsp;A．1：2<br>&nbsp;&nbsp;B．1：3<br>&nbsp;&nbsp;C．1：4<br>&nbsp;&nbsp;D．1：5<br>【答案】 C   <br>【考点】可能性的大小<br> 【难度值】1<br>【解析】可能性的大小 ',
            dialogVisible: false,
            quizDetailInfo: null,
            editor: null,
            quizInfo: null,
            content: '',
            type: 'title',
            selectors: {
                SubjectInfo: [],
                GradeInfo: [],
                QuizTypeInfo: [],
                QuizDiffInfo: [],
                QuizPaperInfo: [],
                QuizTimeOptInfo: [],
            },
            imgDome: null,
            SubjectId: '',
            gradeId: '',
            answerEditor: null,
            titleEditor: null,
            parseEditor: null,
            knowledgePointEditor: null,
            option_aEditor: null,
            option_eEditor: null,
            option_bEditor: null,
            option_cEditor: null,
            option_dEditor: null,
            init: true,
        };
    },
    watch: {
        content(n, o) {

            this.parseQuestion(n)
            setTimeout(() => {
                this.addEventMathField()
            }, 200);
        },
        dialogVisible(n, o) {
            if (!n) {
                this.close()
            }
        },

        'formData.subject'(n, o) {
            if (n !== o && this.formData.grade) {
                this.ExamQuestionBaseData()
            }
        },
        'formData.grade'(n, o) {
            if (n !== o && this.formData.subject) {
                this.ExamQuestionBaseData()
            }

        },
        'formData.answer2'(n, o) {
            if (this.answerEditor) {
                this.answerEditor.txt.clear()
                this.answerEditor.txt.html(this.createVirtualDOM(`${this.formData.answer}&nbsp;`))
            }

        },
        'formData.parse'(n, o) {
            if (this.parseEditor) {
                this.parseEditor.txt.clear()
                this.parseEditor.txt.html(this.createVirtualDOM(`${this.formData.parse}&nbsp;`))
            }

        },
        'formData.title'(n, o) {
            if (n) {
                this.titleEditor.txt.clear()
                this.titleEditor.txt.html(this.createVirtualDOM(`${this.formData.title}&nbsp;`))
            }

        },
        'formData.option_a'(n, o) {
            if (this.option_aEditor) {

                this.option_aEditor.txt.clear()
                this.option_aEditor.txt.html(this.createVirtualDOM(`${'' + this.formData.option_a}&nbsp;`))
            }
            if (n) {
                this.formData.qtype = '选择题'
            }
        },
        'formData.option_b'(n, o) {
            if (this.option_bEditor) {
                this.option_bEditor.txt.html(this.createVirtualDOM(`${'' + this.formData.option_b}&nbsp;`))
            }
        },
        'formData.option_c'(n, o) {
            if (this.option_cEditor) {
                this.option_cEditor.txt.html(this.createVirtualDOM(`${'' + this.formData.option_c}&nbsp;`))
            }
        },
        'formData.option_d'(n, o) {

            if (this.option_dEditor) {
                this.option_dEditor.txt.html(this.createVirtualDOM(`${'' + this.formData.option_d}&nbsp;`))
            }

        },

        'formData.option_e'(n, o) {
            if (this.option_eEditor) {
                this.option_eEditor.txt.html(this.createVirtualDOM(`${'' + this.formData.option_e}&nbsp;`))
            }
        },

        'formData.knowledges'(n, o) {
            if (this.knowledgesEditor) {
                this.knowledgesEditor.txt.html(this.formData.knowledges)
            }
        },

    },
    methods: {

        otherEditor() {
            this.option_aEditor = new E('#option_a')
            this.option_aEditor.config.menus = []
            this.option_aEditor.config.height = 50;
            this.option_aEditor.config.zIndex = 500
            this.option_aEditor.config.showFullScreen = false
            // 配置 onchange 回调函数
            this.option_aEditor.config.onchange = (newHtml) => {
                this.rightFormData.option_a = newHtml.replace(/<\/?(p|math-field|span|div)\b[^>]*>/gi, '')

            };
            this.option_aEditor.create()

            this.option_bEditor = new E('#option_b')
            this.option_bEditor.config.menus = []
            this.option_bEditor.config.height = 50;
            this.option_bEditor.config.zIndex = 500
            this.option_bEditor.config.showFullScreen = false
            // 配置 onchange 回调函数
            this.option_bEditor.config.onchange = (newHtml) => {
                this.rightFormData.option_b = newHtml.replace(/<\/?(p|math-field|span|div)\b[^>]*>/gi, '')

            };
            this.option_bEditor.create()


            this.option_cEditor = new E('#option_c')
            this.option_cEditor.config.menus = []
            this.option_cEditor.config.height = 50;
            this.option_cEditor.config.zIndex = 500
            this.option_cEditor.config.showFullScreen = false
            // 配置 onchange 回调函数
            this.option_cEditor.config.onchange = (newHtml) => {
                this.rightFormData.option_c = newHtml.replace(/<\/?(p|math-field|span|div)\b[^>]*>/gi, '')

            };
            this.option_cEditor.create()


            this.option_dEditor = new E('#option_d')
            this.option_dEditor.config.menus = []
            this.option_dEditor.config.height = 50;
            this.option_dEditor.config.zIndex = 500
            this.option_dEditor.config.showFullScreen = false
            // 配置 onchange 回调函数
            this.option_dEditor.config.onchange = (newHtml) => {
                this.rightFormData.option_d = newHtml.replace(/<\/?(p|math-field|span|div)\b[^>]*>/gi, '')


            };
            this.option_dEditor.create()

            this.option_eEditor = new E('#option_e')
            this.option_eEditor.config.menus = []
            this.option_eEditor.config.height = 50;
            this.option_eEditor.config.zIndex = 500
            this.option_eEditor.config.showFullScreen = false
            // 配置 onchange 回调函数
            this.option_eEditor.config.onchange = (newHtml) => {
                this.rightFormData.option_e = newHtml.replace(/<\/?(p|math-field|span|div)\b[^>]*>/gi, '')

            };
            this.option_eEditor.create()

            this.titleEditor = new E('#title')
            this.titleEditor.config.menus = []
            this.titleEditor.config.height = 200;
            this.titleEditor.config.zIndex = 500
            this.titleEditor.config.showFullScreen = false
            // 配置 onchange 回调函数
            this.titleEditor.config.onchange = (newHtml) => {
                this.rightFormData.title = newHtml.replace(/<\/?(p|math-field|span|div)\b[^>]*>/gi, '')


            };
            this.titleEditor.create()

            this.answerEditor = new E('#answer')
            this.answerEditor.config.menus = []
            this.answerEditor.config.height = 100;
            this.answerEditor.config.zIndex = 500
            this.answerEditor.config.showFullScreen = false
            // 配置 onchange 回调函数
            this.answerEditor.config.onchange = (newHtml) => {
                this.rightFormData.answer2 = newHtml.replace(/<\/?(p|math-field|span|div)\b[^>]*>/gi, '')

            };
            this.answerEditor.create()

            this.knowledgesEditor = new E('#knowledges')
            this.knowledgesEditor.config.menus = []
            this.knowledgesEditor.config.height = 100;
            this.knowledgesEditor.config.zIndex = 500
            this.knowledgesEditor.config.showFullScreen = false
            // 配置 onchange 回调函数
            this.knowledgesEditor.config.onchange = (newHtml) => {
                this.rightFormData.knowledges = newHtml.replace(/<\/?(p|math-field|span|div)\b[^>]*>/gi, '')

            };
            this.knowledgesEditor.create()

            this.parseEditor = new E('#parse')
            this.parseEditor.config.height = 200;
            this.parseEditor.config.zIndex = 500
            this.parseEditor.config.menus = []
            this.parseEditor.config.showFullScreen = false
            // 配置 onchange 回调函数
            this.parseEditor.config.onchange = (newHtml) => {
                console.log(newHtml)
                this.rightFormData.parse = newHtml.replace(/<\/?(p|math-field|span|div)\b[^>]*>/gi, '')

            };
            this.parseEditor.create()

        },
        // 获取完整的题目详情信息
        async ExamQuestionBaseData() {
            const SubjectId = this.selectors.SubjectInfo.find(item => item.subjectName == this.formData.subject).subjectId
            const GradeId = this.selectors.GradeInfo.find(item => item.gradeName == this.formData.grade).gradeId
            const { QuizChapterInfo, QuizDiffInfo, QuizPaperInfo, QuizTypeInfo } = await this.$api.ExamQuestionBaseData({
                SubjectId,
                GradeId,
                TermVal: '1',
            });
            this.selectors = { ...this.selectors, QuizChapterInfo, QuizDiffInfo, QuizPaperInfo, QuizTypeInfo }
            console.log(this.selectors)
        },
        // 获取题目的详细信息
        async getQuestionDetail() {
            const data = await this.$api.getQuestionDetail({
                questionId: this.questionId
            });
            this.quizDetailInfo = data;
        },
        close() {
            console.log('已销毁')
            if (this.type == 'add') {
                if (this.option_aEditor) {
                    this.option_aEditor.destroy()
                }
                if (this.option_bEditor) {
                    this.option_bEditor.destroy()
                }
                if (this.option_cEditor) {
                    this.option_cEditor.destroy()
                }
                if (this.option_dEditor) {
                    this.option_dEditor.destroy()
                }
                if (this.option_eEditor) {
                    this.option_eEditor.destroy()
                }
                this.titleEditor.destroy()
                this.answerEditor.destroy()
                this.knowledgesEditor.destroy()
                this.parseEditor.destroy()
            }
            this.dialogVisible = false
            this.content = ''
            this.formData = {}
            this.rightFormData = {}
            // 销毁编辑器
            this.editor.destroy()
            this.editor = null
        },
        extractQuestions(str) {
            // 使用正向零宽断言分割题号，保留完整题目内容 
            const questionParts = str.split(/(?=\d+．)/g).filter(p => p.trim());
            const questions = [];

            for (let part of questionParts) {
                // 1. 去除换行符、合并连续空格 
                let content = part.replace(/\n/g, ' ')
                    .replace(/\s+/g, ' ')
                    .trim();

                // 2. 动态截取到下一个题号或字符串结束 
                const nextQuestionIndex = content.search(/\d+．/);
                if (nextQuestionIndex !== -1) {
                    content = content.slice(0, nextQuestionIndex);
                }
                const optionEnd = content.lastIndexOf(/[A-D]．.*?\)/);
                if (optionEnd !== -1) {
                    content = content.substring(0, optionEnd + 1);
                }

                questions.push(content);
            }
            return questions;
        },
        splitQuestionsByIndex(text) {
            // 匹配题目标识：数字 + 中文句号（例如：1．、2．）
            const questionStartRegex = /(\d+)(\uFF0E)/g; // \uFF0E 是中文句号 "．"

            const result = [];
            let lastIndex = 0;
            let match;

            // 先找出所有题目标识的位置
            const indexes = [];

            while ((match = questionStartRegex.exec(text)) !== null) {
                indexes.push(match.index);
            }

            if (indexes.length === 0) return [text];

            // 按照题目标识位置切割文本
            for (let i = 0; i < indexes.length; i++) {
                const start = indexes[i];

                // 下一题的位置，如果没有就是文本末尾
                const end = indexes[i + 1] || text.length;

                // 提取题目内容（注意保留标签和换行）
                const questionContent = text.slice(start, end).trim();

                result.push(questionContent);
            }

            return result;
        },
        async save() {
            const value = this.content.trim().replace(/<\/?(math-field|span|div)\b[^>]*>/gi, '')
            if (this.type == 'add') {
                // 检查 formData 的属性是否为空
                for (const [key, val] of Object.entries(this.formData)) {
                    if (!val) {
                        let fieldName;
                        switch (key) {
                            case 'subject':
                                fieldName = '学科';
                                break;
                            case 'grade':
                                fieldName = '年级';
                                break;
                            case 'qtype':
                                fieldName = '题型';
                                break;
                            case 'paperTpye':
                                fieldName = '题类';
                                break;
                            case 'year':
                                fieldName = '时间';
                                break;

                        }
                        if (fieldName) {
                            this.$message({
                                message: `${fieldName}必选`,
                                type: 'warning'
                            });
                            return;
                        }


                    }
                }
                // 检查除选项外的属性是否为空
                let fieldsToCheck = ['title', 'answer2', 'knowledges', 'parse'];
                if (this.formData.qtype == 1) {
                    fieldsToCheck.concat(['option_a', 'option_b',])
                }
                for (const field of fieldsToCheck) {
                    console.log(this.rightFormData[field], field)
                    if (!this.rightFormData[field] || (this.rightFormData[field] && !this.rightFormData[field].trim())) {
                        let fieldName;
                        switch (field) {
                            case 'title':
                                fieldName = '题干';
                                break;
                            case 'knowledges':
                                fieldName = '知识考点';
                                break;
                            case 'parse':
                                fieldName = '解析';
                                break;
                            case 'option_a':
                                fieldName = '选项A';
                                break;
                            case 'option_b':
                                fieldName = '选项B';
                                break;
                            case 'answer2':
                                fieldName = '答案';
                                break;
                        }
                        console.log(fieldName);
                        if (fieldName) {
                            this.$message({
                                message: `${fieldName}不能为空`,
                                type: 'warning'
                            });
                            return;
                        }

                    } else {
                        this.rightFormData[field] = await this.uploadBase64(this.rightFormData[field]);
                    }
                }
                const formValues = {
                    ...this.formData,
                    ...this.rightFormData,
                }
                await this.$api.CreateNewQuestion({
                    "QuizInfo": formValues
                })
                this.$message({
                    message: '新增成功',
                    type: 'success'
                })
                this.close()
                console.log(formValues)
            } else {
                setTimeout(async () => {

                    if (value == '') {
                        this.$message({
                            message: '编辑内容不能为空',
                            type: 'warning'
                        })
                        return
                    }
                    let params = {
                        QuizId: this.quizInfo.id,
                        KeyName: this.type == 'title' ? 'QuizTitle' : this.type,
                        KeyVal: value
                    };
                    try {

                        this.quizInfo[this.type] = value
                        this.$emit('UpdateQuestion', this.quizInfo)
                        setTimeout(() => {
                            this.close()
                        }, 200);
                        await this.$api.ExamUpdateQuestion(params)
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        })
                    } catch (error) {
                        console.log(error)
                    }
                }, 200);
            }


        },
        async uploadBase64(val) {
            if (!val) {
                return ''
            }
            // 创建一个虚拟 DOM 来解析粘贴的内容 
            const parser = new DOMParser();
            const doc = parser.parseFromString(val, 'text/html');

            // 查找所有图片元素 
            const images = doc.querySelectorAll('img');

            for (const img of images) {
                const src = img.src;
                // 判断图片是否为 base64 编码 
                if (src.includes('data:image')) {
                    try {
                        // 模拟上传 base64 图片，返回新的图片路径 
                        const newImageUrl = await this.uploadBase64Image(src);
                        // 替换图片路径 
                        img.src = newImageUrl;
                        // 清除图片的 alt 属性 
                        img.removeAttribute('alt');
                    } catch (error) {
                        console.error(' 图片上传失败:', error);
                    }
                }
            }

            // 将处理后的 DOM 转换回字符串 
            const newPasteStr = doc.body.innerHTML;
            return newPasteStr
        },
        /**
           * 解析题目数组
           * @param {Array<string>} strList - 题目数组
           * @returns {Array<Object>} 解析后的题目对象数组
           */
        async parseQuestion(str) {
            console.log('解析题目数组',);

            if (!str) return {}; // 处理单个题目为空的情况
            const result = {};

            // 提取题目标题
            result.title = this.extractTitle(str);

            // 提取选项
            const options = this.extractOptions(str);

            // 提取答案
            result.answer2 = this.extractAnswer(str);

            // 提取考点
            result.knowledges = this.extractKnowledgePoint(str);
            // 难度值
            result.diff = this.extractDiff(str) || 1;
            // 提取解析
            result.parse = this.extractparse(str);
            this.formData = { ...this.formData, ...result, ...options };
            this.rightFormData = { ...result, ...options };
            console.log(this.formData)
            return { ...result, ...options }; // 返回解析后的题目对象
        },
        removeIncompleteTags(str) {
            // Step 1: 移除特定的 <!--[if --> 和 <!--[endif]--> 注释标签
            str = str.replace(/<!--$$if[^\]]*-->/gi, '')   // 匹配 <!-- [if ... -->
                .replace('<!--[endif]-->', ''); // 匹配 <!-- [endif] -->

            // Step 2: 使用 DOM 解析修复不完整的 HTML 并提取内容
            const parser = new DOMParser();
            const doc = parser.parseFromString(str, 'text/html');

            // Step 3: 提取 body 中的内容（忽略 head）
            const container = document.createElement('div');
            container.innerHTML = '';
            while (doc.body.firstChild) {
                container.appendChild(doc.body.firstChild);
            }

            return container.innerHTML.replace(/<\/?(p|math-field|span|div)\b[^>]*>/gi, '');
        },
        // 提取题目标题
        extractTitle(str) {
            // 先尝试匹配【答案】、选项或者图片标签
            const match = str.match(/【答案】|[A-D]．/);
            const titleEndIndex = match ? match.index : str.length;
            return str.slice(0, titleEndIndex).trim().replace(/<\/?(p|math-field|span|div)\b[^>]*>/gi, '') + '&nbsp;';
        },


        // 提取选项
        extractOptions(str) {
            const options = {};
            const optionLetters = ['A', 'B', 'C', 'D'];
            for (const letter of optionLetters) {
                const regex = new RegExp(`${letter}[．.]([\\s\\S]*?)(?=[A-D][．.]|【答案】|$)`)
                const match = str.match(regex);
                if (match) {
                    options[`option_${letter.toLowerCase()}`] = this.removeIncompleteTags(match[1].trim());
                } else {
                    options[`option_${letter.toLowerCase()}`] = '';
                }
            }
            return options;
        },

        // 提取答案
        extractAnswer(str) {
            const answerMatch = str.match(/【答案】\s*([^【]+)/);
            return this.removeIncompleteTags(answerMatch ? answerMatch[1].trim() : '')
        },

        // 提取考点
        extractKnowledgePoint(str) {
            const knowledgePointMatch = str.match(/【考点】\s*([^【]+)/);
            return this.removeIncompleteTags(knowledgePointMatch ? knowledgePointMatch[1].trim() : '');

        },

        // 提取解析
        extractparse(str) {
            const parseMatch = str.match(/【解析】\s*([\s\S]+?)(?=【|$)/);
            return this.removeIncompleteTags(parseMatch ? parseMatch[1].replace(/<[^>]*>/g, '').trim() : '');

        },
        // 提取难度值
        extractDiff(str) {
            const diffMatch = str.match(/【难度值】\s*([\s\S]+?)(?=【|$)/);
            return this.removeIncompleteTags(diffMatch ? diffMatch[1].replace(/<[^>]*>/g, '').trim() : '');

        },


        replaceMathField(id, html, newValue) {
            // 创建一个临时容器来解析 HTML
            const tempContainer = document.createElement('div');
            tempContainer.innerHTML = html;

            // 查找所有 math-field 元素
            const fields = tempContainer.querySelectorAll('math-field');
            for (const field of fields) {
                if (field.id === id) {
                    field.innerHTML = newValue; // 替换匹配元素的内容
                    break; // 替换第一个匹配项即可
                }
            }
            // 返回更新后的 HTML
            return tempContainer.innerHTML;
        },
        open(value, type) {
            this.dialogVisible = true
            this.type = type
            console.log(type)
            this.quizInfo = value
            if (type === 'add') {
                this.content = ''
                this.selectors = JSON.parse(localStorage.getItem('ExamQuestionOpenInfo'));
                const currentYear = new Date().getFullYear() + 1; // 获取当前年份
                this.selectors.QuizTimeOptInfo = Array.from({ length: 5 }, (_, i) => ({ label: currentYear - i, value: currentYear - i, }));
                console.log(this.selectors.QuizTimeOptInfo);
                setTimeout(() => {
                    this.otherEditor()
                }, 500);

            }
            if (value) {
                this.content = value[type].replace(/<\/?(math-field|span|div)\b[^>]*>/gi, '')
            }

            this.$nextTick(() => {
                this.createEditor()

            })
        },
        // 选择页面上所有的<math-field>元素
        addEventMathField() {
            const mathFieldElements = document.querySelectorAll('math-field');
            mathFieldElements.forEach((element, index) => {
                // 添加事件监听器，例如监听'input'事件
                element.menuItems = [
                    {
                        label: '删除',
                        onMenuSelect: (e) => {
                            let element = document.getElementById(e.target.id);
                            element.remove();
                        },
                    },
                ]
                element.addEventListener('input', (event) => {
                    const html = this.editor.txt.html()
                    this.content = this.replaceMathField(event.target.id, html, `\\(${element.getValue()}\\)`).replace(/<\/?(math-field|span|div)\b[^>]*>/gi, '')
                });
                element.addEventListener('focus', (event) => {
                    window.mathVirtualKeyboard.visible = true;
                });
            });

        },
        /**
         * 给每张图片新增个id
         * @param htmlString 
         */
        ImgListener() {
            const editorElement = document.querySelector('#wangEditor');
            if (!editorElement) return;

            // 监听拖拽事件
            editorElement.addEventListener('dragstart', function (e) {
                console.log(e)
                // 判断是否是图片被拖拽
                if (e.target.tagName === 'IMG') {
                    e.preventDefault(); // 必须阻止默认行为，才能触发 drop
                }
            });
        },
        showCustomImageMenu(e, imgElement) {
            e.preventDefault();

            // 移除已存在的菜单 
            const existingMenu = document.getElementById('custom-image-menu');
            if (existingMenu) {
                document.body.removeChild(existingMenu);
            }

            // 创建菜单元素 
            const menu = document.createElement('div');
            menu.id = 'custom-image-menu';
            Object.assign(menu.style, {
                position: 'absolute',
                left: `${e.clientX}px`,
                top: `${e.clientY}px`,
                backgroundColor: '#fff',
                border: '1px solid #ddd',
                boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                zIndex: '10000',
                borderRadius: '4px',
                overflow: 'hidden',
                minWidth: '120px'
            });

            const menuItems = [
                { text: '文本环绕左对齐', action: () => this.editImg(imgElement, 'float-left') },
                { text: '文本环绕右对齐', action: () => this.editImg(imgElement, 'float-right') },
                { separator: true },
                { text: '单独居左', action: () => this.editImg(imgElement, 'block-left') },
                { text: '单独居中', action: () => this.editImg(imgElement, 'block-center') },
                { text: '单独居右', action: () => this.editImg(imgElement, 'block-right') },
                { separator: true },
                { text: '移至顶部', action: () => this.editImg(imgElement, 'top') },
                { text: '移至底部', action: () => this.editImg(imgElement, 'bottom') }
            ];

            // 添加菜单项 
            menuItems.forEach(item => {
                if (item.separator) {
                    const separator = document.createElement('div');
                    Object.assign(separator.style, {
                        height: '1px',
                        backgroundColor: '#eee',
                        margin: '4px 0'
                    });
                    menu.appendChild(separator);
                    return;
                }

                const itemElement = document.createElement('div');
                Object.assign(itemElement.style, {
                    padding: '8px 16px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    color: '#333'
                });
                itemElement.textContent = item.text;

                // 鼠标悬停效果 
                itemElement.addEventListener('mouseenter', () => {
                    itemElement.style.backgroundColor = '#f0f0f0';
                });
                itemElement.addEventListener('mouseleave', () => {
                    itemElement.style.backgroundColor = '#fff';
                });

                // 点击事件 
                itemElement.addEventListener('click', (e) => {
                    e.stopPropagation();
                    item.action();
                    this.removeMenu();
                });

                menu.appendChild(itemElement);
            });

            // 添加到文档 
            document.body.appendChild(menu);

            // 点击其他地方关闭菜单 
            this.closeMenuHandler = (e) => {
                if (!menu.contains(e.target)) {
                    this.removeMenu();
                }
            };

            // 使用捕获阶段确保在其他点击之前执行
            document.addEventListener('click', this.closeMenuHandler, true);
        },

        removeMenu() {
            const menu = document.getElementById('custom-image-menu');
            if (menu) {
                document.body.removeChild(menu);
            }
            if (this.closeMenuHandler) {
                document.removeEventListener('click', this.closeMenuHandler, true);
                this.closeMenuHandler = null;
            }
        },
        //修改图片位置
        editImg(img, align) {
            const parent = img.parentElement;
            const isInParagraph = parent.tagName.toLowerCase() === 'p';

            // 保留原有样式，只清除与对齐相关的样式 
            img.style.float = '';
            img.style.margin = '';
            img.style.display = '';

            // 清除父元素的对齐样式（如果是p标签）
            if (isInParagraph) {
                parent.style.textAlign = '';
                parent.style.overflow = '';
            }

            switch (align) {
                case 'float-left':
                    this.moveImageToPosition(img, 'first');
                    img.style.float = 'left';
                    img.style.marginRight = '10px';
                    if (isInParagraph) {
                        parent.style.overflow = 'hidden';
                    }
                    break;

                case 'float-right':
                    this.moveImageToPosition(img, 'first');
                    img.style.float = 'right';
                    img.style.marginLeft = '10px';
                    if (isInParagraph) {
                        parent.style.overflow = 'hidden';
                    }
                    break;

                case 'block-left':
                    img.style.display = 'block';
                    img.style.marginRight = 'auto';
                    if (isInParagraph) {
                        parent.style.textAlign = 'left';
                    }
                    break;

                case 'block-center':
                    img.style.display = 'block';
                    img.style.marginLeft = 'auto';
                    img.style.marginRight = 'auto';
                    if (isInParagraph) {
                        parent.style.textAlign = 'center';
                    }
                    break;

                case 'block-right':
                    img.style.display = 'block';
                    img.style.marginLeft = 'auto';
                    if (isInParagraph) {
                        parent.style.textAlign = 'right';
                    }
                    break;

                case 'top':
                    this.moveImageToPosition(img, 'first');
                    break;

                case 'bottom':
                    this.moveImageToPosition(img, 'last');
                    break;
            }
        },

        moveImageToPosition(img, position) {
            const parent = img.parentElement;
            const isInParagraph = parent.tagName.toLowerCase() === 'p';

            img.style.display = 'block';

            if (isInParagraph) {
                const grandParent = parent.parentElement;
                // 移动图片到新位置 
                if (position === 'first') {
                    grandParent.insertBefore(img, grandParent.firstChild);
                } else {
                    grandParent.appendChild(img);
                }

                // 如果原p标签为空则移除
                if (parent.childNodes.length === 0) {
                    grandParent.removeChild(parent);
                }
            } else {
                // 从当前位置移除
                parent.removeChild(img);

                // 添加到新位置
                if (position === 'first') {
                    parent.insertBefore(img, parent.firstChild);
                } else {
                    parent.appendChild(img);
                }
            }
        },
        //判断点击的是哪个图片
        imgClickEvents(e) {
            this.imgDome = e.selector
        },
        async uploadBase64Image(base64Data) {
            // 将 Base64 转换为 Blob 对象 
            const byteCharacters = atob(base64Data.split(',')[1]);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: base64Data.split(',')[0].split(':')[1].split(';')[0] });

            // 创建 FormData 对象 
            const formData = new FormData();
            formData.append('UploadFile', blob, new Date().getTime() + '.jpg')
            formData.append('ResType', 'USR_RES_QUESTPIC')
            try {
                // 发起异步请求 
                const result = await this.$api.UploadPic(formData);
                return window.origin + result.ResName;
            } catch (error) {
                console.error(' 上传过程中出现错误:', error);
                throw error;
            }
        },
        //创建编辑器
        createEditor() {
            this.editor = new E('#wangEditor');
            const editor = this.editor
            editor.config.height = 650;
            editor.config.uploadImgMaxLength = 1
            editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
            editor.config.showLinkImgHref = false
            // 注册菜单
            editor.menus.extend("kityformulaKey", Kityformula);
            editor.config.menus = [
                'head',
                'fontSize',
                'lineHeight',
                'foreColor',
                'backColor',
                'justify',
                'image',
                'undo',
                'redo',
                "kityformulaKey",
            ]
            // 配置 server 接口地址
            editor.config.uploadImgServer = '/UploadPic'
            editor.config.uploadImgParams = {
                ResType: 'USR_RES_QUESTPIC',

            }
            editor.config.uploadImgHooks = {
                customInsert: function (insertImgFn, result) {
                    // result 即服务端返回的接口
                    console.log('customInsert', result)

                    // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
                    insertImgFn(window.origin + result.ResName)
                }
            }
            // 配置粘贴文本的内容处理
            editor.config.pasteTextHandle = (pasteStr) => {
                // 返回处理后的结果 
                return this.createVirtualDOM(pasteStr);
            };
            editor.config.withCredentials = true
            editor.config.uploadFileName = 'UploadFile'

            // 配置 onchange 回调函数
            editor.config.onchange = async (newHtml) => {
                this.content = newHtml.replace(/<\/?(math-field|span|div)\b[^>]*>/gi, '')

            };
            // 配置触发 onchange 的时间频率，默认为 200ms
            editor.config.onchangeTimeout = 500; // 修改为 500ms
            editor.txt.eventHooks.imgClickEvents.push(this.imgClickEvents)
            editor.create();
            if (this.content) {
                editor.txt.html(this.createVirtualDOM(`${this.content}&nbsp;`));
            }
            //图片监听
            this.ImgListener()
            const editorContainer = document.querySelector('#wangEditor');
            //添加监听鼠标右击事件
            editorContainer.addEventListener('contextmenu', (e) => {
                console.log(e)
                // 检查是否点击的是图片 
                if (e.target.tagName === 'IMG' || e.target.className == 'w-e-img-drag-mask') {

                    this.showCustomImageMenu(e, e.target.className == 'w-e-img-drag-mask' ? this.imgDome : e.target)
                }
            })
            document.body.style.setProperty("--keyboard-zindex", "5000");

        },
        //解析字符串创建虚拟dome
        createVirtualDOM(str) {
            const results = [];
            const combinedPattern = /(\\begin\{.*?\}.*?\\end\{.*?\}|\\\[[^]*?\\\]|\\\([^]*?\\\)|\$[^]*?\$|\\\w+|\\[^\s\\{}]+|<img\s[^>]*>)/gs;

            // 生成本次函数调用的唯一标识（避免不同调用间ID冲突）
            const callUUID = `dom_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 6)}`;

            // 分割字符串并过滤空值
            const parts = [];
            let lastIndex = 0;
            let match;

            while ((match = combinedPattern.exec(str)) !== null) {
                if (match.index > lastIndex) {
                    parts.push(str.substring(lastIndex, match.index));
                }
                parts.push(match[0]);
                lastIndex = match.index + match[0].length;
            }
            if (lastIndex < str.length) parts.push(str.substring(lastIndex));

            // 处理每个分段 
            parts.filter(Boolean).forEach((element, index) => {
                const isLatex = /^\\/.test(element) || /^\$/.test(element);
                const isImage = /^<img/i.test(element);

                // 添加唯一ID到图片标签 
                if (isImage) {
                    const imgId = `${callUUID}_img${index}`;
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(element, 'text/html');
                    const img = doc.querySelector('img');

                    if (img) {
                        img.id = imgId;
                        element = img.outerHTML;  // 更新为带ID的标签 
                    }
                }

                results.push({
                    type: isLatex ? 'latex' : isImage ? 'image' : 'text',
                    value: element,
                    // 为图片元素附加ID元数据
                    ...(isImage && { metadata: { id: `${callUUID}_img${index}` } })
                });
            });
            const mathfield = new Date().getTime();
            // 构建HTML输出  
            return results.reduce((html, item, idx) => {
                switch (item.type) {
                    case 'latex':
                        return html + `<math-field id="math-field${mathfield}" style="border: none;">${item.value}</math-field>`;
                    default:
                        return html + item.value;
                }
            }, '');
        }
    }
};
</script>
<style scoped>
svg {
    font-size: 16px;
    color: red;
}

img {
    position: absolute;
}

/* 添加自定义菜单样式 */
#custom-image-menu {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

#custom-image-menu div {
    transition: background-color 0.2s;
}

#custom-image-menu div:not(:last-child) {
    border-bottom: 1px solid #eee;
}
</style>